<template>
  <ul
    class="index-advantage-component app-basic-layout-wrapper app app-flex-row"
  >
    <li
      v-for="(item, index) in list"
      :key="index"
      class="item"
      :class="`item-${index + 1}`"
    >
      <h4 class="font-26 label app-flex-row">
        <i class="iconfont icon-a-"></i>{{ item.label }}
      </h4>
      <p class="title">{{ item.title }}</p>
      <p class="desc font-color-desc font-14">{{ item.desc }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      activeIndex: null,
      list: [
        {
          label: '用户规模',
          title: '全网领先的全用户及时长覆盖',
          desc: '微博月活用户突破5亿，覆盖各兴趣垂类人群，用户活跃度及留存稳步提升'
        },
        {
          label: '服务体系',
          title: '全营销链路服务能力',
          desc: '多场景的数字营销能力，打造全面专业的一站式服务支持'
        },
        {
          label: '技术能力',
          title: '数据赋能精准营销',
          desc: '提供各类丰富精准的数据，结合DSP技术与数据能力，助力广告主实现精准数字营销'
        },
        {
          label: '效果评估',
          title: '深度的广告追踪',
          desc: '微博独特的开放型社交生态，广告均可与用户产生真实互动与关注，效果可评估追踪并可后续建立深度联系'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.index-advantage-component {
  .item {
    width: 50%;
    height: 228px;
    box-sizing: border-box;
    padding-top: 48px;
    cursor: pointer;
    background: $neutral-color-1 no-repeat left top/cover;
    padding-left: 44px;
    padding-right: 197px;
    .label {
      justify-content: flex-start;
      .iconfont {
        margin-right: 14px;
        margin-top: -18px;
      }
    }
    .title {
      margin: 24px 0 8px;
    }
    // 奇数
    &:nth-of-type(odd) {
      border-right: 1px solid $text-color-other;
    }
    &:nth-of-type(even) {
      border-left: 1px solid $text-color-other;
    }
    // 倒数两个
    &:nth-child(-n + 2) {
      border-bottom: 2px solid $text-color-other;
    }
  }
  @for $i from 1 through 4 {
    .item.item-#{$i}:hover {
      background-image: url('~@/assets/img/index-advantage-bg-#{$i}.png');
    }
  }
}
</style>
